export default __webpack_public_path__ + "static/media/primary-plus.8a609663.svg";